import React, { createContext, useContext, useState, useEffect } from 'react';
import { getWishlist } from '../services/api';
import { useAuth } from './AuthContext';

const WishlistContext = createContext();

export const useWishlist = () => {
  const context = useContext(WishlistContext);
  if (!context) {
    throw new Error('useWishlist must be used within a WishlistProvider');
  }
  return context;
};

export const WishlistProvider = ({ children }) => {
  const [wishlistCount, setWishlistCount] = useState(0);
  const [wishlistItems, setWishlistItems] = useState([]);
  const { isAuthenticated } = useAuth();

  const updateWishlistCount = async () => {
    if (!isAuthenticated()) {
      setWishlistCount(0);
      setWishlistItems([]);
      return;
    }

    try {
      const response = await getWishlist();
      if (response.success) {
        const items = response.wishlist || [];
        setWishlistCount(items.length);
        setWishlistItems(items);
      }
    } catch (error) {
      console.error('Error updating wishlist count:', error);
      setWishlistCount(0);
      setWishlistItems([]);
    }
  };

  useEffect(() => {
    updateWishlistCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated]);

  const refreshWishlist = () => {
    updateWishlistCount();
  };

  return (
    <WishlistContext.Provider value={{
      wishlistCount,
      wishlistItems,
      refreshWishlist
    }}>
      {children}
    </WishlistContext.Provider>
  );
};

